import { action, observable } from 'mobx'
import Ds from './ds'

class Quickbooks {
  /**
   * Observables
   **/
  @observable ds = new Ds()

  @observable qbItemList = [{
    id: 0,
    name: 'Loading...'
  }]

  @observable qbItem = {
    id: 0,
    name: 'Loading...'
  }

  @observable qbTermsList = []/*[{
    id: 0,
    name: 'Loading...'
  }]*/

  @observable qbTaxRatesList = []/*[{
    id: 0,
    name: 'Loading...',
    taxRate: 'Loading...'
  }]*/

  @observable qbPaymentMethods = []

  /**
   * Actions
   **/
  @action getQuickbooksCustomerInfo(qbCustomerId, callback) {
    const query = `{ quickbooksCustomerDetails( organizationId: ${ localStorage.getItem('userOrganizationId') }, hash: "${ localStorage.getItem('userHash') }", qbCustomerId: ${ qbCustomerId } ) { statusCode data } }`
    console.log(query)
    this.ds.query(query, (data) => {
      if (callback) {
        callback(data)
      }
    })
  }

   @action getQuickbooksCompanyInfo(callback) {
     const query = `{ quickbooksCompanyDetails( organizationId: ${ localStorage.getItem('userOrganizationId') }, hash: "${ localStorage.getItem('userHash') }" ) { statusCode data } }`
     console.log(query)
     this.ds.query(query, (data) => {
       if (callback) {
         callback(data)
       }
     })
   }

   @action getQuickbooksCompanyItems(callback) {
     const query = `{ quickbooksGetCompanyItems( organizationId: ${ localStorage.getItem('userOrganizationId') }, hash: "${ localStorage.getItem('userHash') }" ) { statusCode data } }`
     console.log(query)
     this.ds.query(query, (data) => {
        if (data.quickbooksGetCompanyItems.statusCode == 200) { 
        this.qbItemList = data.quickbooksGetCompanyItems.data.results.body.QueryResponse.Item.map((item) => {
           return {Id: item.Id, Name: item.Name, Description: item.Description, Cost: item.UnitPrice}
         })
       } else {
        this.qbItemList = [
          {
            statusCode: data.quickbooksGetCompanyItems.statusCode,
            message: data.quickbooksGetCompanyItems.data.message
          }
        ]
       }

       if (callback) {
         callback(this.qbItemList)
       }
     })
   }

   @action getQuickbooksCompanyItem(itemId, callback) {
     const query = `{ quickbooksGetCompanyItem( organizationId: ${ localStorage.getItem('userOrganizationId') }, hash: "${ localStorage.getItem('userHash') }", itemId: ${ itemId } ) { statusCode data } }`
     console.log(query)
     this.ds.query(query, (data) => {
       if (data.quickbooksGetCompanyItem.statusCode == 200) {
         this.qbItem = {id: data.quickbooksGetCompanyItem.data.results.body.Item.Id, name: data.quickbooksGetCompanyItem.data.results.body.Item.Name}
       } else {
        this.qbItem = {
          statusCode: data.quickbooksGetCompanyItem.statusCode,
          message: data.quickbooksGetCompanyItem.data.message
          }
       }

       if (callback) {
         callback(this.qbItem)
       }

     })
   }

   @action getQuickbooksTerms(callback) {
     const query = `{ quickbooksGetCompanyTerms( organizationId: ${ localStorage.getItem('userOrganizationId') }, hash: "${ localStorage.getItem('userHash') }" ) { statusCode data } }`
     console.log(query)
     this.ds.query(query, (data) => {
       if (data.quickbooksGetCompanyTerms.statusCode == 200) {
         this.qbTermsList = data.quickbooksGetCompanyTerms.data.results.body.QueryResponse.Term.map((term) => {
           return {id: term.Id, name: term.Name}
         })
       } else {
        this.qbTermsList = [
          {
            statusCode: data.quickbooksGetCompanyTerms.statusCode,
            message: data.quickbooksGetCompanyTerms.data.message
          }
        ]
       }

       if (callback) {
         callback(this.qbTermsList)
       }
     })
   }

   @action getQuickbooksTaxRates(callback) {
     const query = `{ quickbooksGetCompanyTaxRates( organizationId: ${ localStorage.getItem('userOrganizationId') }, hash: "${ localStorage.getItem('userHash') }" ) { statusCode data } }`
     this.ds.query(query, (data) => {
       if (data.quickbooksGetCompanyTaxRates.statusCode == 200) {
         this.qbTaxRatesList = data.quickbooksGetCompanyTaxRates.data.results.body.QueryResponse.TaxRate.map((code) => {
           return {id: code.Id, name: code.Name, taxRate: code.RateValue}
         })
       } else {
        this.qbTaxRatesList = [
          {
            statusCode: data.quickbooksGetCompanyTaxRates.statusCode,
            message: data.quickbooksGetCompanyTaxRates.data.message
          }
        ]
       }

       if (callback) {
         callback(this.qbTaxRatesList)
       }
     })
   }

   @action getQuickbooksPaymentMethods(callback) {
    const query = `{ quickbooksGetCompanyPaymentMethods( organizationId: ${ localStorage.getItem('userOrganizationId') }, hash: "${ localStorage.getItem('userHash') }" ) { statusCode data } }`
    console.log(query)
    this.ds.query(query, (data) => {
      if (data.quickbooksGetCompanyPaymentMethods.statusCode == 200) {
        this.qbPaymentMethods = data.quickbooksGetCompanyPaymentMethods.data.results.body.QueryResponse.PaymentMethod.map((paymentMethod) => {
          return {id: paymentMethod.Id, name: paymentMethod.Name, type: paymentMethod.Type}
        })
      } else {
       this.qbPaymentMethods = [
         {
           statusCode: data.quickbooksGetCompanyPaymentMethods.statusCode,
           message: data.quickbooksGetCompanyPaymentMethods.data.message
         }
       ]
      }

      if (callback) {
        callback(this.qbPaymentMethods)
      }
    })
  }

   @action quickbooksCreateCustomer(companyId, callback) {
    const query = `{ quickbooksCreateCustomer(
      hash: "${ localStorage.getItem('userHash') }",
      companyId: ${ companyId },
      organizationId: ${ localStorage.getItem('userOrganizationId') }
     ) { statusCode data } }`

     console.log(query)
     this.ds.query(query, (data) => {
       if (callback) {
         callback(data)
       }
     })
   }

   @action quickbooksUpdateCustomer(companyId, callback) {
    const query = `{ quickbooksUpdateCustomer(
      hash: "${ localStorage.getItem('userHash') }",
      companyId: ${ companyId },
      organizationId: ${ localStorage.getItem('userOrganizationId') }
     ) { statusCode data } }`

     console.log(query)
     this.ds.query(query, (data) => {
       if (callback) {
         callback(data)
       }
     })
   }

   @action quickbooksCreateInvoice(params, callback) {
     const query = `{ quickbooksCreateInvoice(
      organizationId: ${ localStorage.getItem('userOrganizationId') },
      hash: "${ localStorage.getItem('userHash') }",
      quoteId: ${ params.invoiceId },
      companyId: ${ params.companyId },
      qbCustomerId: ${ params.qbCustomerId },
      txnDate: "${ params.txnDate }",
      note: "${ params.note }",
      paymentTermId: ${ params.paymentTermId },
      taxRateId: ${ params.taxRateId },
      billingCompany: "${ params.billingCompany }",
      billingName: "${ params.billingName }",
      billingAddress: "${ params.billingAddress }",
      billingCity: "${ params.billingCity }",
      billingState: "${ params.billingState }",
      billingZipCode: "${ params.billingZipCode }",
      shippingName: "${ params.shippingName }",
      shippingAddress: "${ params.shippingAddress }",
      shippingCity: "${ params.shippingCity }",
      shippingState: "${ params.shippingState }",
      shippingZipCode: "${ params.shippingZipCode }",
      shippingCost: "${ params.shippingCost }",
      email: "${ params.email }",
      hardwareList: "${ params.hardwareList }",
      accessoryList: "${ params.accessoryList }",
      featureList: "${ params.featureList }"
     ) { statusCode data } }`

     console.log(query)
     this.ds.query(query, (data) => {
       if (callback) {
         callback(data)
       }
     })
   }

   @action quickbooksUpdateInvoice(params, callback) {
     const query = `{ quickbooksUpdateInvoice(
      organizationId: ${ localStorage.getItem('userOrganizationId') },
      hash: "${ localStorage.getItem('userHash') }",
      qbOrderNumber: "${ params.qbOrderNumber }",
      companyId: ${ params.companyId },
      qbCustomerId: "${ params.qbCustomerId }",
      txnDate: "${ params.txnDate }",
      note: "${ params.note }",
      paymentTermId: ${ params.paymentTermId },
      taxRateId: ${ params.taxRateId },
      billingCompany: "${ params.billingCompany }",
      billingName: "${ params.billingName }",
      billingAddress: "${ params.billingAddress }",
      billingCity: "${ params.billingCity }",
      billingState: "${ params.billingState }",
      billingZipCode: "${ params.billingZipCode }",
      shippingName: "${ params.shippingName }",
      shippingAddress: "${ params.shippingAddress }",
      shippingCity: "${ params.shippingCity }",
      shippingState: "${ params.shippingState }",
      shippingZipCode: "${ params.shippingZipCode }",
      shippingCost: "${ params.shippingCost }",
      email: "${ params.email }",
      hardwareList: "${ params.hardwareList }",
      accessoryList: "${ params.accessoryList }",
      featureList: "${ params.featureList }"
     ) { statusCode data } }`

     console.log(query)
     this.ds.query(query, (data) => {
       if (callback) {
         callback(data)
       }
     })
   }

   @action processNewCustomerPayment(params, callback) {
    const query = `{ quickbooksNewBillPayment(
      organizationId: ${ params.organizationId }
      quoteToken: "${ params.invoiceToken }"
      stripeCustomerId: "${ params.stripeCustomerId }"
      stripeToken: "${ params.stripeToken}"
      total: ${ params.total }
      email: "${ params.email }"
    ) { statusCode data } }`

    console.log(query)
    this.ds.query(query, (data) => {
      if (callback) {
        callback(data)
      }
    })
  }

  @action processExistingCustomerPayment(params, callback) {
    const query = `{ quickbooksExistingBillPayment(
      organizationId: ${ params.organizationId },
      quoteToken: "${ params.invoiceToken }"
      stripeCustomerId: "${ params.stripeCustomerId}"
      stripeCardId: "${ params.stripeCardId}"
      total: ${ params.total }
      email: "${ params.email }"
    ) { statusCode data } }`

    console.log(query)
    this.ds.query(query, (data) => {
      if (callback) {
        callback(data)
      }
    })
  }

  @action processManualCustomerPayment(params, callback) {
    const query = `{ quickbooksManualBillPayment(
      organizationId: ${ params.organizationId },
      quoteToken: "${ params.invoiceToken }"
      paymentMethodId: ${ params.paymentMethodId },
      total: ${ params.total }
      email: "${ params.email }"
    ) { statusCode data } }`

    console.log(query)
    this.ds.query(query, (data) => {
      if (callback) {
        callback(data)
      }
    })
  }

  @action getQuickbooksInvoicePDF(qbOrderNumber, callback) {
    const query = `{ quickbooksInvoicePDF(
      organizationId: ${ localStorage.getItem('userOrganizationId') },
      hash: "${ localStorage.getItem('userHash') }",
      qbOrderNumber: "${ qbOrderNumber }"
    ) { statusCode data } }`

    console.log(query)
    this.ds.query(query, (data) => {
      if (callback) {
        callback(data)
      }
    })
  }

   @action connect(callback) {
    const query = `{
      quickbooksConnect( hash: "${ localStorage.getItem('userHash') }" )
    }`

    this.ds.query(query, (data) => {
      if (callback) {
        callback(data.status)
      }
    })
  }

  @action callback(args, callback) {
    const query = `{
      quickbooksCallback( hash: "${ localStorage.getItem('userHash') }", state: "${ args.state }", code: "${ args.code }" ) {
        status
        message
      }
    }`

    console.log(query)

    this.ds.query(query, (data) => {
      if (callback) {
        callback(data)
      }
    })
  }

  @action intuitSignin(callback) {
    const query = `{
      quickbooksConnectUri( hash: "${ localStorage.getItem('userHash') }", callbackUri: "${ window.location.protocol }://${ window.location.hostname }:${ window.location.port }/quickbooks/callback" ) {
        uri
      }
    }`

    console.log(query)

    this.ds.query(query, (data) => {
      if (callback) {
        callback(data)
      }
    })
  }
}

export default new Quickbooks()



// WEBPACK FOOTER //
// ./src/stores/quickbooks.js